<app-supplier-auction-offer-list-ssy1280detail [state]="viewState.Create"></app-supplier-auction-offer-list-ssy1280detail>